import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import {
  MemberValues,
  CostValues,
  PEPM,
  PMPM,
  TotalCost,
  TotalEnrolled,
} from '../core-utils/helper-utils/summaryReportHelper';

interface ToggleValue {
  toggleValue?: 'and' | 'or';
}

export class SummaryCardsStore {
  totalEligible: number = 0;
  totalEnrolled: TotalEnrolled = {
    dependents: '',
    totalCount: '',
    employees: '',
  };
  totalCost: TotalCost = {
    totalCost: '',
    totalRx: '',
    totalMedical: '',
  };
  pmpm: PMPM = {
    pmpm: '',
    pmpmPercentage: '',
    increment: false,
  };
  pepm: PEPM = {
    pepm: '',
    pepmPercentage: '',
    increment: false,
  };
  memberIds: string[] = [];
  response: any = {};
  costValues: CostValues = {
    medical: '$0.00',
    rx: '$0.00',
    total: '$0.00',
  };
  memberValues: MemberValues = {
    members: '0',
    employees: '0',
    dependents: '0',
  };
  toggleConditions: ToggleValue[] = [];

  constructor() {
    makeObservable(this, {
      totalEligible: observable,
      totalEnrolled: observable,
      totalCost: observable,
      pmpm: observable,
      pepm: observable,
      memberIds: observable,
      response: observable,
      costValues: observable,
      memberValues: observable,
      toggleConditions: observable,
      addTotalEligible: action,
      removeTotalEligible: action,
      addTotalEnrolled: action,
      removeTotalEnrolled: action,
      addTotalCost: action,
      removeTotalCost: action,
      addPMPM: action,
      removePMPM: action,
      addPEPM: action,
      removePEPM: action,
      addMemberIds: action,
      removeMemberIds: action,
      addResponse: action,
      removeResponse: action,
      addCostValues: action,
      removeCostValues: action,
      addMemberValues: action,
      removeMemberValues: action,
      addToggleConditions: action,
    });
    makePersistable(this, {
      name: 'SummaryCardsStore',
      properties: [
        'totalEligible',
        'totalEnrolled',
        'totalCost',
        'pmpm',
        'pepm',
        'memberIds',
        'response',
        'costValues',
        'memberValues',
        'toggleConditions',
      ],
      storage: window.localStorage,
    });
  }
  addTotalEligible(totalEligible: number) {
    this.totalEligible = totalEligible;
  }
  addTotalEnrolled(totalCount: string, dependents: string, employees: string) {
    this.totalEnrolled.dependents = dependents;
    this.totalEnrolled.totalCount = totalCount;
    this.totalEnrolled.employees = employees;
  }
  addTotalCost(totalCost: string, totalRx: string, totalMedical: string) {
    this.totalCost.totalCost = totalCost;
    this.totalCost.totalRx = totalRx;
    this.totalCost.totalMedical = totalMedical;
  }
  addPMPM(pmpm: string, pmpmPercentage: string, increment: boolean) {
    this.pmpm.pmpm = pmpm;
    this.pmpm.increment = increment;
    this.pmpm.pmpmPercentage = pmpmPercentage;
  }
  addPEPM(pepm: string, pepmPercentage: string, increment: boolean) {
    this.pepm.pepm = pepm;
    this.pepm.pepmPercentage = pepmPercentage;
    this.pepm.increment = increment;
  }

  addToggleConditions(conditions: ToggleValue[]) {
    this.toggleConditions = conditions;
  }

  removeToggleConditions() {
    this.toggleConditions = [];
  }

  removeTotalEligible() {
    this.totalEligible = 0;
  }
  removeTotalEnrolled() {
    this.totalEnrolled = {
      dependents: '',
      totalCount: '',
      employees: '',
    };
  }
  removeTotalCost() {
    this.totalCost = {
      totalCost: '',
      totalRx: '',
      totalMedical: '',
    };
  }
  removePMPM() {
    this.pmpm = {
      pmpm: '',
      pmpmPercentage: '',
      increment: false,
    };
  }
  removePEPM() {
    this.pepm = {
      pepm: '',
      pepmPercentage: '',
      increment: false,
    };
  }

  addMemberIds(memberIds: string[]) {
    this.memberIds = memberIds;
  }

  removeMemberIds() {
    this.memberIds = [];
  }

  addResponse(response: any) {
    this.response = response;
  }

  removeResponse() {
    this.response = {};
  }

  addCostValues(costValues: CostValues) {
    this.costValues = costValues;
  }

  removeCostValues() {
    this.costValues = {
      rx: '',
      medical: '',
      total: '',
    };
  }

  addMemberValues(memberValues: MemberValues) {
    this.memberValues = memberValues;
  }

  removeMemberValues() {
    this.memberValues = {
      members: '',
      employees: '',
      dependents: '',
    };
  }
}
export default SummaryCardsStore;
